import RestApiModel from "@/api/Model/RestApiModel";

class Referral extends RestApiModel {
  static getResourceEndpoint() {
    return '/Referral';
  }
}

export default Referral;
